import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'byPassSecurity'
})
export class ByPassSecurityPipe implements PipeTransform {
    constructor(private domSanitizer: DomSanitizer) { }

    transform(value: string): SafeHtml {
        if (!value) {
            return value;
        } else {
            value = value.replace(/<script/ig, '<no_scrippt');
            value = value.replace(/<\/script/ig, '</no_scrippt');
            value = value.replace(/on([a-z]+[:space:]*)=/ig, 'on_$1=');

            return this.domSanitizer.bypassSecurityTrustHtml(value); // OK
            // return this.domSanitizer.sanitize(SecurityContext.HTML, this.domSanitizer.bypassSecurityTrustHtml(value)); // OK
            // return this.domSanitizer.sanitize(SecurityContext.NONE, this.domSanitizer.bypassSecurityTrustHtml(value)); // OK
            // return this.domSanitizer.bypassSecurityTrustStyle(value);
            // return this.domSanitizer.bypassSecurityTrustScript(value);
            // return this.domSanitizer.bypassSecurityTrustResourceUrl(value);
        }
    }
}
